// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import {
    getInstanceSurveys as listInstanceSurveysAPI,
    getInstanceSurvey as getInstanceSurveyAPI,
    addInstanceSurvey as addInstanceSurveyAPI,
    updateInstanceSurvey as updateInstanceSurveyAPI,
    deleteInstanceSurvey as deleteInstanceSurveyAPI,
    addInstanceSurveyQr as addInstanceSurveyQrAPI,
    updateInstanceSurveyQr as updateInstanceSurveyQrAPI
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { instanceSurveysApiResponseError, instanceSurveysApiResponseSuccess } from './actions';
import { InstanceSurveysActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getInstanceSurvey({ payload: { id } }) {
    try {
        const response = yield call(getInstanceSurveyAPI, id);
        const instanceSurveyItem = response.data.data;
        yield put(instanceSurveysApiResponseSuccess(InstanceSurveysActionTypes.GET_INSTANCE_SURVEY, instanceSurveyItem));
    } catch (error) {
        yield put(instanceSurveysApiResponseError(InstanceSurveysActionTypes.GET_INSTANCE_SURVEY, error));
    }
}

function* addInstanceSurvey({ payload: instanceSurvey }) {
    try {
        const response = yield call(addInstanceSurveyAPI, { ...instanceSurvey })
        const instanceSurveyItem = response.data.data
        yield put(instanceSurveysApiResponseSuccess(InstanceSurveysActionTypes.ADD_INSTANCE_SURVEY, instanceSurveyItem))
    } catch (error) {
        yield put(instanceSurveysApiResponseError(InstanceSurveysActionTypes.ADD_INSTANCE_SURVEY, error))
    }
}

function* updateInstanceSurvey({ payload: instanceSurvey }) {
    try {
        const response = yield call(updateInstanceSurveyAPI, { ...instanceSurvey })
        const instanceSurveyItem = response.data
        yield put(instanceSurveysApiResponseSuccess(InstanceSurveysActionTypes.UPDATE_INSTANCE_SURVEY, instanceSurveyItem))
    } catch (error) {
        yield put(instanceSurveysApiResponseError(InstanceSurveysActionTypes.UPDATE_INSTANCE_SURVEY, error))
    }
}
function* deleteInstanceSurvey({ payload: { id } }) {
    try {
        const response = yield call(deleteInstanceSurveyAPI, id)
        const instanceSurveyItem = response.data.id
        yield put(instanceSurveysApiResponseSuccess(InstanceSurveysActionTypes.DELETE_INSTANCE_SURVEY, instanceSurveyItem))
    } catch (error) {
        yield put(instanceSurveysApiResponseError(InstanceSurveysActionTypes.DELETE_INSTANCE_SURVEY, error))
    }
}

/**
 * List contactos
 */
function* listInstanceSurveys({ payload: params }) {
    try {
        const response = yield call(listInstanceSurveysAPI, { ...params });
        const listaInstanceSurveys = response.data.data;
        yield put(instanceSurveysApiResponseSuccess(InstanceSurveysActionTypes.LIST_INSTANCE_SURVEYS, listaInstanceSurveys));
    } catch (error) {
        yield put(instanceSurveysApiResponseError(InstanceSurveysActionTypes.LIST_INSTANCE_SURVEYS, error));
    }
}

function* addInstanceSurveyQr({ payload: instanceSurvey }) {
    try {
        const response = yield call(addInstanceSurveyQrAPI, { ...instanceSurvey })
        const instanceSurveyItem = response.data.data
        yield put(instanceSurveysApiResponseSuccess(InstanceSurveysActionTypes.ADD_INSTANCE_SURVEY_QR, instanceSurveyItem))
    } catch (error) {
        yield put(instanceSurveysApiResponseError(InstanceSurveysActionTypes.ADD_INSTANCE_SURVEY_QR, error))
    }
}

function* updateInstanceSurveyQr({ payload: instanceSurvey }) {
    try {
        const response = yield call(updateInstanceSurveyQrAPI, { ...instanceSurvey })
        const instanceSurveyItem = response.data
        yield put(instanceSurveysApiResponseSuccess(InstanceSurveysActionTypes.UPDATE_INSTANCE_SURVEY_QR, instanceSurveyItem))
    } catch (error) {
        yield put(instanceSurveysApiResponseError(InstanceSurveysActionTypes.UPDATE_INSTANCE_SURVEY_QR, error))
    }
}

export function* watchGetInstanceSurvey(): any {
    yield takeEvery(InstanceSurveysActionTypes.GET_INSTANCE_SURVEY, getInstanceSurvey);
}

export function* watchListInstanceSurveys(): any {
    yield takeEvery(InstanceSurveysActionTypes.LIST_INSTANCE_SURVEYS, listInstanceSurveys);
}

export function* watchAddInstanceSurvey(): any {
    yield takeEvery(InstanceSurveysActionTypes.ADD_INSTANCE_SURVEY, addInstanceSurvey)
}
export function* watchUpdateInstanceSurvey(): any {
    yield takeEvery(InstanceSurveysActionTypes.UPDATE_INSTANCE_SURVEY, updateInstanceSurvey)
}
export function* watchDeleteInstanceSurvey(): any {
    yield takeEvery(InstanceSurveysActionTypes.DELETE_INSTANCE_SURVEY, deleteInstanceSurvey)
}
export function* watchAddInstanceSurveyQr(): any {
    yield takeEvery(InstanceSurveysActionTypes.ADD_INSTANCE_SURVEY_QR, addInstanceSurveyQr)
}
export function* watchUpdateInstanceSurveyQr(): any {
    yield takeEvery(InstanceSurveysActionTypes.UPDATE_INSTANCE_SURVEY_QR, updateInstanceSurveyQr)
}

function* instanceSurveysSaga(): any {
    yield all([
        fork(watchGetInstanceSurvey),
        fork(watchListInstanceSurveys),
        fork(watchAddInstanceSurvey),
        fork(watchUpdateInstanceSurvey),
        fork(watchDeleteInstanceSurvey),
        fork(watchAddInstanceSurveyQr),
        fork(watchUpdateInstanceSurveyQr)
    ]);
}

export default instanceSurveysSaga;
